import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';

// Components
import { staticConfig } from './config/static';
import { Authentication } from './domain/auth/Authentication';
import { Routing } from './domain/Routing';
import { RootProvider } from './providers';

// Styles
import './styles/styles.scss';

const App = lazy(() => import('./domain/App'));

const applicationRootElement = document.getElementById('root');

const renderApplication = (): void => {
    render(
        <React.StrictMode>
            <RootProvider>
                <Routing>
                    <Authentication>
                        <Suspense fallback={null}>
                            <App />
                        </Suspense>
                    </Authentication>
                </Routing>
            </RootProvider>
        </React.StrictMode>,
        applicationRootElement
    );
};

// Use for local development when mocking the proxy backend
const renderApplicationWithoutAuthentication = (): void => {
    render(
        <React.StrictMode>
            <RootProvider>
                <Routing>
                    <Suspense fallback={null}>
                        <App />
                    </Suspense>
                </Routing>
            </RootProvider>
        </React.StrictMode>,
        applicationRootElement
    );
};

if (Boolean(staticConfig.useProxyMock)) {
    renderApplicationWithoutAuthentication();
} else {
    renderApplication();
}
